import { useEffect, useState } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom'
import { XCircleIcon, XIcon } from '@heroicons/react/solid'
import axios from "axios";
import IsAuth from '../../utillityComponents/IsAuth';
import PacmanLoader from "react-spinners/PacmanLoader";
import moment from 'moment';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { ADMIN_API_URL } from '../../api/axios';

const parseApiError = (err) => {
  const data = err?.response?.data;
  if (data?.error) return typeof data.error === 'string' ? data.error : JSON.stringify(data.error);
  if (data?.message) return data.message;
  if (data) return JSON.stringify(data);
  return err?.message || 'Der opstod en uventet fejl';
};

export default function EventEdit() {
  const { event_slug } = useParams();
  const navigate = useNavigate();
  const axiosPrivat = useAxiosPrivate();

  const [photoFile, setPhotoFile] = useState(null);
  const [eventName, setEventName] = useState('');
  const [orgSlug, setOrgSlug] = useState('');
  const [eventImg, seteventImg] = useState('');
  const [orgName, setOrgName] = useState(false);
  const [orgList, setOrgList] = useState([]);
  const [eventSlug, setEventSlug] = useState('');
  const [sportstimingEventApiKey, setSportstimingEventApiKey] = useState('');
  const [eventStartTime, setEventStartTime] = useState(null);
  const [eventEndTime, setEventEndTime] = useState(null);
  const [loading, setLoading] = useState(false);
  const [eventDescription, setEventDescription] = useState('');
  const [canSignUpForMembership, setCanSignUpForMembership] = useState(null);
  const [publicDonation, setPublicDonation] = useState(null);
  const [hideOnFrontpage, setHideOnFrontpage] = useState(null);
  const [isPublic, setIsPublic] = useState(null);
  const [allowSignUp, setAllowSignUp] = useState(null);
  const [activateSportstiming, setActivateSportstiming] = useState(false);
  const [sportstimingEventId, setSportstimingEventId] = useState(null);
  const [allowDelete, setAllowDelete] = useState(false);
  const [groupEvents, setGroupEvents] = useState([]);
  const [groupEventId, setGroupEventId] = useState(null);
  const [confirmIportSportstiming, setConfirmIportSportstiming] = useState(false);
  const [eventClosedAt, setEventClosedAt] = useState(null);
  const [afslutEventet, setAfslutEventet] = useState(false);
  const [appCodes, setAppCodes] = useState([]);
  const [error, setError] = useState(null);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(null);

  const downloadPdf = async (type) => {
    if (pdfLoading) return;
    setPdfLoading(type);
    try {
      const response = await axiosPrivat.get(
        `event/get/${event_slug}/${type}/pdf`,
        { responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      const nameMap = {
        'start-package-participant': 'start-pakke-elev',
        'start-package-org': 'start-pakke-skole',
        'event-app-guide': 'omgange-vejledning',
      };
      link.setAttribute('download', `${eventName} - ${nameMap[type] || type}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } finally {
      setPdfLoading(null);
    }
  };

  const uploadAxios = axios.create({
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('aT'),
      'Content-Type': 'multipart/form-data',
    },
  });

  const getEvent = async () => {
    try {
      const response = await uploadAxios.get(ADMIN_API_URL + "/event/get/" + event_slug);
      setEventName(response.data.name);
      setOrgSlug(response.data.org_slug);
      setEventSlug(response.data.slug);
      setEventStartTime(response.data.event_start_date);
      setEventEndTime(response.data.event_end_date);
      setOrgName(response.data.org.name);
      seteventImg(response.data.img);
      setEventDescription(response.data.description);
      setCanSignUpForMembership(response.data.can_sign_up_for_membership);
      setHideOnFrontpage(response.data.hide_on_frontpage);
      setAllowSignUp(response.data.has_public_sign_up);
      setIsPublic(response.data.is_public);
      setGroupEventId(response.data.event_group_id);
      setPublicDonation(response.data.public_donations);
      setActivateSportstiming(response.data.sportstiming_enabled);
      setSportstimingEventId(response.data.sportstiming_event_id);
      setEventClosedAt(response.data.event_closed_at);
      setSportstimingEventApiKey(response.data.sportstiming_client_secret);
      setAppCodes(response.data.app_codes || []);
    } catch (err) {
      console.error(err);
      setError(parseApiError(err));
    }
  };

  const getAllEventGroups = async () => {
    try {
      setLoading(true);
      const response = await axiosPrivat.get(ADMIN_API_URL + '/event-group/get/all');
      setGroupEvents(response.data);
    } catch (err) {
      console.error(err);
      setError(parseApiError(err));
    }
    setLoading(false);
  };

  const getOrgList = async () => {
    try {
      const response = await axiosPrivat.get('settings/org/all/auth');
      setOrgList(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getAllEventGroups();
    getEvent();
    getOrgList();
    // eslint-disable-next-line
  }, [event_slug]);

  const handleChange = (file) => {
    setPhotoFile(file[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const formData = new FormData();
    formData.append("name", eventName);
    formData.append("org_slug", orgSlug);
    formData.append("can_sign_up_for_membership", canSignUpForMembership);
    formData.append("description", eventDescription);
    formData.append("slug", eventSlug);
    formData.append("event_start_date", new Date(eventStartTime).toISOString().replace(/.000/, ""));
    formData.append("event_end_date", new Date(eventEndTime).toISOString().replace(/.000/, ""));
    formData.append("event_group_id", groupEventId);
    formData.append("public_donations", publicDonation);
    formData.append("sportstiming_enabled", activateSportstiming);
    formData.append("sportstiming_secret", sportstimingEventApiKey);

    if (afslutEventet === true) {
      formData.append("event_closed_at", true);
    }

    if (sportstimingEventId !== null) {
      formData.append("sportstiming_event_id", sportstimingEventId);
    }

    if (photoFile !== null) {
      formData.append("img", photoFile);
    }
    if (hideOnFrontpage !== null) {
      formData.append("hide_on_frontpage", hideOnFrontpage);
    }
    if (allowSignUp !== null) {
      formData.append("has_public_sign_up", allowSignUp);
    }
    if (isPublic !== null) {
      formData.append("is_public", isPublic);
    }

    try {
      setError(null);
      setLoading(true);
      await uploadAxios.post(ADMIN_API_URL + '/event/update/' + event_slug, formData);
      if (isMounted) {
        setSaveSuccess(true);
        setTimeout(() => setSaveSuccess(false), 3000);
      }
    } catch (err) {
      console.error(err);
      setError(parseApiError(err));
    }
    setLoading(false);

    return () => { isMounted = false; };
  };

  const deleteEvent = async (eSlug) => {
    if (allowDelete !== true) {
      setError("Sæt kryds i bekræft sletning for at slette eventet.");
      return;
    }
    try {
      setError(null);
      setLoading(true);
      await uploadAxios.delete(ADMIN_API_URL + '/event/delete/' + eSlug);
      setLoading(false);
      navigate('/events');
    } catch (err) {
      console.error(err);
      setError(parseApiError(err));
      setLoading(false);
    }
  };

  const importSportstiming = async (eSlug) => {
    if (confirmIportSportstiming !== true) {
      setError("Sæt kryds i bekræft sportstiming import.");
      return;
    }
    try {
      setError(null);
      setLoading(true);
      await uploadAxios.post(ADMIN_API_URL + '/event/import/' + eSlug + '/sportstiming');
      setLoading(false);
    } catch (err) {
      console.error(err);
      setError(parseApiError(err));
      setLoading(false);
    }
  };

  const dataLoaded = eventName !== '';

  return (
    <div className="px-4 sm:px-6 lg:max-w-4xl lg:mx-auto lg:px-0 py-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <Link to="/events" className="text-sm text-indigo-600 hover:text-indigo-800 mb-1 inline-block">
            ← Tilbage til events
          </Link>
          <h2 className="text-xl font-semibold text-gray-900">Ændre event</h2>
          {orgName && <p className="text-sm text-gray-500">{orgName}</p>}
        </div>
      </div>

      {error && (
        <div className="mb-4 rounded-md bg-red-50 p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
            </div>
            <div className="ml-3 flex-1">
              <p className="text-sm text-red-700">{error}</p>
            </div>
            <div className="ml-auto pl-3">
              <button type="button" onClick={() => setError(null)} className="inline-flex rounded-md bg-red-50 p-1.5 text-red-500 hover:bg-red-100">
                <XIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      )}

      {saveSuccess && (
        <div className="mb-4 rounded-md bg-green-50 p-4">
          <p className="text-sm text-green-700">Ændringer gemt.</p>
        </div>
      )}

      <div className="bg-white rounded-lg shadow ring-1 ring-black ring-opacity-5">
        <form id="update-event-form" onSubmit={handleSubmit}>
          <div className="px-6 py-4">
            {/* Section: Event detaljer */}
            <div className="mb-6">
              <h4 className="text-base font-semibold text-gray-900 border-b pb-2 mb-4">Event detaljer</h4>
              <div className="space-y-4">
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                  <label htmlFor="event-name" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    Event navn
                  </label>
                  <div className="mt-1 sm:mt-0 sm:col-span-2">
                    <input
                      type="text"
                      name="event-name"
                      id="event-name"
                      onChange={(e) => setEventName(e.target.value)}
                      value={eventName}
                      className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                      required
                    />
                  </div>
                </div>

                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                  <label htmlFor="event-description" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    Event beskrivelse
                  </label>
                  <div className="mt-1 sm:mt-0 sm:col-span-2">
                    <textarea
                      rows={6}
                      name="event-description"
                      id="event-description"
                      value={eventDescription}
                      onChange={(e) => setEventDescription(e.target.value)}
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      required
                    />
                  </div>
                </div>

                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                  <label htmlFor="event-slug" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    Event prefix
                  </label>
                  <div className="mt-1 sm:mt-0 sm:col-span-2">
                    <input
                      type="text"
                      name="event-slug"
                      id="event-slug"
                      onChange={(e) => setEventSlug(e.target.value)}
                      value={eventSlug}
                      className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md bg-gray-50"
                      required
                      readOnly
                    />
                  </div>
                </div>

                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                  <label htmlFor="orginasation" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    Organisation
                  </label>
                  <div className="mt-1 sm:mt-0 sm:col-span-2">
                    {orgName ?
                      <select
                        id="orginasation"
                        name="orginasation"
                        onChange={(e) => setOrgSlug(e.target.value)}
                        className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                        defaultValue={orgSlug}
                      >
                        <option key="0" disabled></option>
                        {orgList.map((org) => (
                          <option key={org.id} value={org.slug}>{org.name}</option>
                        ))}
                      </select>
                    : null}
                  </div>
                </div>

                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                  <label htmlFor="eventgruppe" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    Eventgruppe
                  </label>
                  <div className="mt-1 sm:mt-0 sm:col-span-2">
                    {!loading ?
                      <select
                        id="eventgruppe"
                        name="eventgruppe"
                        onChange={(e) => setGroupEventId(e.target.value)}
                        className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                        defaultValue={groupEventId}
                      >
                        <option key="0" value="null"></option>
                        {groupEvents.map((group_events) => (
                          <option key={group_events.id} value={group_events.id}>{group_events.name}</option>
                        ))}
                      </select>
                    : null}
                  </div>
                </div>
              </div>
            </div>

            {/* Section: Tidspunkt */}
            <div className="mb-6">
              <h4 className="text-base font-semibold text-gray-900 border-b pb-2 mb-4">Tidspunkt</h4>
              <div className="space-y-4">
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                  <label htmlFor="start-time" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    Start dato
                  </label>
                  <div className="mt-1 sm:mt-0 sm:col-span-2">
                    <input
                      type="datetime-local"
                      id="start-time"
                      className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                      onChange={(e) => setEventStartTime(e.target.value)}
                      value={moment(eventStartTime).format("yyyy-MM-DDTHH:mm")}
                      name="start-time"
                    />
                  </div>
                </div>

                <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                  <label htmlFor="end-time" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    Slut dato
                  </label>
                  <div className="mt-1 sm:mt-0 sm:col-span-2">
                    <input
                      type="datetime-local"
                      id="end-time"
                      className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                      onChange={(e) => setEventEndTime(e.target.value)}
                      value={moment(eventEndTime).format("yyyy-MM-DDTHH:mm")}
                      name="end-time"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Section: Billede */}
            <div className="mb-6">
              <h4 className="text-base font-semibold text-gray-900 border-b pb-2 mb-4">Billede</h4>
              <div className="flex items-center space-x-4">
                <img
                  className="h-12 w-12 rounded-lg object-cover"
                  src={eventImg + "/36x36"}
                  alt={eventName}
                />
                <input
                  name="image"
                  id="image"
                  type="file"
                  onChange={(e) => handleChange(e.target.files)}
                  className="bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                />
              </div>
            </div>

            {/* Section: Indstillinger */}
            {IsAuth(['Admin', 'Ngo']) ?
              <div className="mb-6">
                <h4 className="text-base font-semibold text-gray-900 border-b pb-2 mb-4">Indstillinger</h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {dataLoaded && (
                    <>
                      <label className="flex items-center space-x-3 p-3 rounded-lg border border-gray-200 hover:bg-gray-50 cursor-pointer">
                        <input
                          type="checkbox"
                          defaultChecked={canSignUpForMembership}
                          onChange={(e) => setCanSignUpForMembership(e.target.checked)}
                          className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        />
                        <span className="text-sm font-medium text-gray-700">Kan tilmelde sig medlemskab</span>
                      </label>

                      <label className="flex items-center space-x-3 p-3 rounded-lg border border-gray-200 hover:bg-gray-50 cursor-pointer">
                        <input
                          type="checkbox"
                          defaultChecked={allowSignUp}
                          onChange={(e) => setAllowSignUp(e.target.checked)}
                          className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        />
                        <span className="text-sm font-medium text-gray-700">Åben for tilmelding</span>
                      </label>

                      <label className="flex items-center space-x-3 p-3 rounded-lg border border-gray-200 hover:bg-gray-50 cursor-pointer">
                        <input
                          type="checkbox"
                          defaultChecked={hideOnFrontpage}
                          onChange={(e) => setHideOnFrontpage(e.target.checked)}
                          className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        />
                        <span className="text-sm font-medium text-gray-700">Skjul på forside</span>
                      </label>

                      <label className="flex items-center space-x-3 p-3 rounded-lg border border-gray-200 hover:bg-gray-50 cursor-pointer">
                        <input
                          type="checkbox"
                          defaultChecked={publicDonation}
                          onChange={(e) => setPublicDonation(e.target.checked)}
                          className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        />
                        <span className="text-sm font-medium text-gray-700">Public donations</span>
                      </label>

                      <label className="flex items-center space-x-3 p-3 rounded-lg border border-gray-200 hover:bg-gray-50 cursor-pointer">
                        <input
                          type="checkbox"
                          defaultChecked={isPublic}
                          onChange={(e) => setIsPublic(e.target.checked)}
                          className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        />
                        <span className="text-sm font-medium text-gray-700">Aktiver event</span>
                      </label>

                      {eventClosedAt == null ?
                        <label className="flex items-center space-x-3 p-3 rounded-lg border border-gray-200 hover:bg-gray-50 cursor-pointer">
                          <input
                            type="checkbox"
                            defaultChecked={afslutEventet}
                            onChange={(e) => setAfslutEventet(e.target.checked)}
                            className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                          />
                          <span className="text-sm font-medium text-gray-700">Afslut eventet</span>
                        </label>
                      :
                        <div className="flex items-center space-x-3 p-3 rounded-lg border border-gray-200 bg-gray-50">
                          <span className="text-sm font-medium text-gray-500">Afsluttet:</span>
                          <span className="text-sm text-gray-700">{moment(eventClosedAt).format("yyyy-MM-DDTHH:mm")}</span>
                        </div>
                      }
                    </>
                  )}
                </div>
              </div>
            : null}

            {/* Section: Sportstiming */}
            {!loading && IsAuth(['Admin', 'Ngo']) ?
              <div className="mb-6">
                <h4 className="text-base font-semibold text-gray-900 border-b pb-2 mb-4">Sportstiming</h4>
                <div className="space-y-4">
                  <label className="flex items-center space-x-3 p-3 rounded-lg border border-gray-200 hover:bg-gray-50 cursor-pointer">
                    <input
                      type="checkbox"
                      defaultChecked={activateSportstiming}
                      onChange={(e) => setActivateSportstiming(e.target.checked)}
                      className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                    />
                    <span className="text-sm font-medium text-gray-700">Aktiver Sportstiming</span>
                  </label>

                  <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                    <label htmlFor="sportstiming-event-id" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Sportstiming Event Id
                    </label>
                    <div className="mt-1 sm:mt-0 sm:col-span-2">
                      <input
                        type="text"
                        name="sportstiming-event-id"
                        id="sportstiming-event-id"
                        onChange={(e) => setSportstimingEventId(e.target.value)}
                        value={sportstimingEventId}
                        className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                      />
                    </div>
                  </div>

                  <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                    <label htmlFor="sportstiming-event-api-key" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Sportstiming Event Api Key
                    </label>
                    <div className="mt-1 sm:mt-0 sm:col-span-2">
                      <input
                        type="text"
                        name="sportstiming-event-api-key"
                        id="sportstiming-event-api-key"
                        onChange={(e) => setSportstimingEventApiKey(e.target.value)}
                        value={sportstimingEventApiKey}
                        className="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                      />
                    </div>
                  </div>

                  <div className="flex items-center justify-between p-3 rounded-lg border border-gray-200">
                    <label className="flex items-center space-x-3 cursor-pointer">
                      <input
                        type="checkbox"
                        defaultChecked={confirmIportSportstiming}
                        onChange={(e) => setConfirmIportSportstiming(e.target.checked)}
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                      />
                      <span className="text-sm font-medium text-gray-700">Bekræft import fra sportstiming</span>
                    </label>
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      onClick={() => importSportstiming(eventSlug)}
                    >
                      Import fra sportstiming
                    </button>
                  </div>
                </div>
              </div>
            : null}

            {/* Section: Hjælpematerialer */}
            <div className="mb-6">
              <h4 className="text-base font-semibold text-gray-900 border-b pb-2 mb-4">Hjælpematerialer</h4>
              <div className="flex flex-wrap gap-3">
                {[
                  { type: 'start-package-participant', label: 'Startpakke deltager' },
                  { type: 'start-package-org', label: 'Startpakke organisation' },
                  { type: 'event-app-guide', label: 'Event app guide' },
                ].map(({ type, label }) => (
                  <button
                    key={type}
                    type="button"
                    disabled={!!pdfLoading}
                    className={`inline-flex items-center rounded-md border border-gray-300 shadow-sm px-4 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${pdfLoading === type ? 'bg-gray-100 text-gray-400 cursor-not-allowed animate-pulse' : pdfLoading ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
                    onClick={() => downloadPdf(type)}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>

            {/* Section: Omgange app */}
            <div className="mb-6">
              <h4 className="text-base font-semibold text-gray-900 border-b pb-2 mb-4">Omgange app</h4>
              {appCodes.length > 0 ? (
                <div className="flex flex-wrap gap-2">
                  {appCodes.map((code) => (
                    <span key={code} className="inline-flex rounded-full bg-indigo-100 px-3 py-1 text-sm font-medium text-indigo-800">
                      {code}
                    </span>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-gray-500">Ingen app koder tilknyttet.</p>
              )}
            </div>

            {/* Section: Farezone */}
            {!loading && IsAuth(['Admin']) ?
              <div className="mb-2">
                <h4 className="text-base font-semibold text-red-600 border-b border-red-200 pb-2 mb-4">Farezone</h4>
                <div className="p-4 rounded-lg border border-red-200 bg-red-50">
                  <div className="flex items-center justify-between">
                    <label className="flex items-center space-x-3 cursor-pointer">
                      <input
                        type="checkbox"
                        defaultChecked={allowDelete}
                        onChange={(e) => setAllowDelete(e.target.checked)}
                        className="focus:ring-red-500 h-4 w-4 text-red-600 border-gray-300 rounded"
                      />
                      <span className="text-sm font-medium text-red-700">Bekræft sletning</span>
                    </label>
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                      onClick={() => deleteEvent(eventSlug)}
                    >
                      Slet Event
                    </button>
                  </div>
                </div>
              </div>
            : null}
          </div>

          {/* Footer */}
          <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 rounded-b-lg flex flex-row-reverse gap-3">
            {!loading ?
              <>
                <button
                  type="submit"
                  form="update-event-form"
                  className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
                >
                  Gem
                </button>
                <button
                  type="button"
                  className="inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
                  onClick={() => navigate('/events')}
                >
                  Annuller
                </button>
              </>
              : <PacmanLoader
                  color="#26103c"
                  cssOverride={{margin: "20px auto"}}
                  loading
                  margin={0}
                  size={24}
                  speedMultiplier={1}
                />
            }
          </div>
        </form>
      </div>
    </div>
  );
}
